export default "__VITE_ASSET__rzNkhRbf__"